import vsComponent from './vsCheckbox';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
